
var recaptchaCallback = function() {}
function loadCaptcha(callback) {
    if(is_ios_app()) { return false; }
    if(sk_config.recaptcha_loaded === false) {
        if(callback) recaptchaCallback = callback;
        setTimeout(function(){
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.onload = function() {
			sk_config.recaptcha_loaded = true;
		};
		script.src = "https://www.google.com/recaptcha/api.js?render=" + sk_config.recaptcha + "&hl=" + sk_config.iso639 + "&onload=recaptchaCallback";
		script.async = true;
		head.appendChild(script);
		}, 1);
    }
    else {
        if(callback) callback();
    }
}

function captcha(action, callback) {
    if(is_ios_app()) {
        callback("ios_app");
        return;
    }
    loadCaptcha(function() {

        grecaptcha.execute('6LcbSNoUAAAAAMZbJOEJU1fTu680L1kbJFUf1oz-', {action: action}).then(function (token) {
            callback(token);
        });
        recaptchaCallback = function() {};
    });
}
